export default __webpack_public_path__ + "static/media/Delta.37762f7b.png";